import { CALL_OUT_OF_JURISDICTION } from '@rsos/constants/collaborator';
import { useGetSelectedCollaborator } from '@rsos/reduxDataStore/src/features/emergencyCalls/helpers';
import InfoBanner from './OverviewTab/InfoBanner';

const CollaboratorBanner = () => {
  const collaborator = useGetSelectedCollaborator();

  const callEnded = collaborator?.callEnded || false;

  const getCallStatusText = () => {
    if (callEnded) {
      return 'Call ended.';
    }
    return 'Call in progress.';
  };

  if (!collaborator?.type) {
    return null;
  }

  return (
    <InfoBanner backgroundColor="lightWarning" color="lightWarningText">
      {collaborator.type === CALL_OUT_OF_JURISDICTION ? (
        <>
          Call out of jurisdiction. Caller within{' '}
          <strong>{collaborator.pairedAccountName}</strong> limits.
        </>
      ) : (
        <>
          Call routed to <strong>{collaborator.pairedAccountName}</strong>
          {collaborator.dispatcherPosition && (
            <>. Answered by position {collaborator.dispatcherPosition}</>
          )}
          . {getCallStatusText()}
        </>
      )}
    </InfoBanner>
  );
};

export default CollaboratorBanner;
